import JSZip from "jszip";
import { message } from "antd";

import filesaver from "@/util/filesaver";

export const addProtocol = (url) => {
  if (url.startsWith("http")) {
    return url;
  }
  return `https:${url}`;
};

export const downloadUrlsAsZip =  (originUrl = [], names, zipName) => {
  return new Promise(async(resolve, reject) => {
    const urls = originUrl.map(addProtocol);
    if (urls.length === 0) {
      resolve();
      return;
    }

    if (urls.length === 1) {
      message.loading({
        content: "正在下载中, 请稍等...",
      });
      filesaver.saveAs(urls[0], names[0]);
      resolve();
    } else {
      message.loading({
        content: "正在打包 0/" + urls.length,
        key: "downloadUrlsAsZip",
        duration: 0,
      });

      const zip = new JSZip();
      const promises = urls.map((url, index) => {
        return filesaver.getBlobOfUrl(url).then((blob) => {
          zip.file(names[index], blob);
          message.loading({
            content: `正在打包 ${index + 1}/${urls.length}`,
            key: "downloadUrlsAsZip",
            duration: 0,
          });
        });
      });

      try {
        await Promise.all(promises);
        const content = await zip.generateAsync({ type: "blob" });
        filesaver.saveAs(content, zipName);
        message.success({
          content: "打包完成，开始下载...",
          key: "downloadUrlsAsZip",
          duration: 2,
        });
        resolve();
      } catch (error) {
        message.error({
          content: "打包失败，请重试",
          key: "downloadUrlsAsZip",
          duration: 2,
        });
        reject(error);
      }
    }

  });
};



// WEBPACK FOOTER //
// ./src/containers/Video/widgets/download-urls-as-zip.js